module.exports = __webpack_public_path__ + "static/media/We-hoped-for-more.f7c2491b.jpg";